import { render, staticRenderFns } from "./revise.vue?vue&type=template&id=79d11fd2&scoped=true"
import script from "./revise.vue?vue&type=script&lang=js"
export * from "./revise.vue?vue&type=script&lang=js"
import style0 from "./revise.vue?vue&type=style&index=0&id=79d11fd2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79d11fd2",
  null
  
)

export default component.exports